import {useEffect, useState} from 'react'
const regionId = localStorage.getItem('er_region_id')

export const useRegion = (setPage) => {
    const [region, setRegion] = useState(!!regionId ? JSON.parse(regionId) : {
        code: 0, id: 0, name: "Федеральный сайт"
    })

    useEffect(()=> {
        localStorage.setItem('er_region_id', JSON.stringify(region))
    }, [region, setPage])



    return {
        region,
        setRegion
    }
}
